/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class V3StartSegmentorIncidentResponse {
    'status'?: string;
    'action'?: string;
    'incidentId'?: string;
    'startTime'?: Date;
    'segmentorStatus'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "status",
            "baseName": "status",
            "type": "string",
            "format": ""
        },
        {
            "name": "action",
            "baseName": "action",
            "type": "string",
            "format": ""
        },
        {
            "name": "incidentId",
            "baseName": "incidentId",
            "type": "string",
            "format": ""
        },
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "segmentorStatus",
            "baseName": "segmentorStatus",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StartSegmentorIncidentResponse.attributeTypeMap;
    }

    public constructor() {
    }
}

